export default __webpack_public_path__ + "static/media/heart-diseases.bdbe787d.jpg";